module.exports = __webpack_public_path__ + "media/images/athletes/1890-4cdc86fac2849c76eb202289e686e206.png";